import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  managerConfig: {},
  corporationData: {
    info: {},
  },
  userConfig: {
    loading: false,
    logged: false,
    userData: {},
    platformId: null,
    language: "es",
    literals: [],
    rol: null,
    token: null,
    componentActive: "userSelect",
    datatable: {
      configuration: { maxRows: 10, indexStart: 0, pages: [0], filterBy: { section: "", filter: [] } },
      requestQuery: {},
      tables: {},
    },
    alerts: [],
    floatPanel: {
      visible: false,
      queryId: null,
      isEmpty: true,
      data: {},
    },
    order: {},
    cart: [],
  },
};

const userConfigSlice = createSlice({
  name: "aplicationConfig",
  initialState,
  reducers: {
    setCorporationData: (state, action) => {
      state.corporationData.info = action.payload;
    },
    setLoading: (state, action) => {
      state.userConfig.loading = action.payload;
    },
    setAlert: (state, action) => {
      const id = new Date().getTime(); // ID único basado en el tiempo
      state.userConfig.alerts.push({ id, ...action.payload });
    },
    removeAlert: (state, action) => {
      state.userConfig.alerts = state.userConfig.alerts.filter((alert) => alert.id !== action.payload);
    },
    setPlatformId: (state, action) => {
      state.userConfig.platformId = action.payload;
    },
    setUserData: (state, action) => {
      state.userConfig.userData = action.payload;
    },
    setUserLogged: (state, action) => {
      state.userConfig.logged = action.payload;
    },
    setUserLogOut: (state) => {
      state.userConfig.logged = false;
      state.userConfig.token = null;
    },
    setUserLanguage: (state, action) => {
      state.userConfig.language = action.payload;
    },
    setLanguage: (state, action) => {
      state.userConfig.literals = action.payload;
    },
    setUserRol: (state, action) => {
      state.userConfig.rol = action.payload;
    },
    setToken: (state, action) => {
      state.userConfig.token = action.payload;
      state.userConfig.logged = true;
    },
    setComponentActive: (state, action) => {
      state.userConfig.floatPanel.visible = false;
      state.userConfig.componentActive = action.payload;
    },
    updateDatatableConfiguration: (state, action) => {
      state.userConfig.datatable.configuration = action.payload;
    },
    updateDatatableFilter: (state, action) => {
      const { section, filter } = action.payload;
      state.userConfig.datatable.configuration.filterBy.section = section;
      state.userConfig.datatable.configuration.filterBy.filter = filter;
    },
    updateDatatableCheckColumn: (state, action) => {
      const { checkColumn = null, table = "default" } = action.payload;

      // Aseguramos que las propiedades necesarias existen
      if (!state.userConfig.datatable.tables[table]) {
        state.userConfig.datatable.tables[table] = {
          checkColumn: false,
          selectedRows: [],
        };
      }

      // Actualizamos el valor
      state.userConfig.datatable.tables[table].checkColumn =
        checkColumn === null ? !state.userConfig.datatable.tables[table].checkColumn : checkColumn;
    },
    updateDatatableSelectedRows: (state, action) => {
      const { selectedRows = [], table = "default" } = action.payload;

      // Aseguramos que las propiedades necesarias existen
      if (!state.userConfig.datatable.tables[table]) {
        state.userConfig.datatable.tables[table] = {
          checkColumn: false,
          selectedRows: [],
        };
      }

      // Actualizamos el valor
      state.userConfig.datatable.tables[table].selectedRows = selectedRows;
    },
    updateDatatableRequestQuery: (state, action) => {
      state.userConfig.datatable.requestQuery = action.payload;
    },
    updateFloatPanelVisibility: (state) => {
      state.userConfig.floatPanel.visible = !state.userConfig.floatPanel.visible;
    },
    setFloatPanelComponent: (state, action) => {
      state.userConfig.floatPanel.component = action.payload;
    },
    updateFloatPanel: (state, action) => {
      const { visible, queryId, isEmpty, data = {} } = action.payload;
      state.userConfig.floatPanel.visible = visible;
      state.userConfig.floatPanel.queryId = queryId;
      state.userConfig.floatPanel.isEmpty = isEmpty;
      state.userConfig.floatPanel.data = data;
    },
    setManagerConfiguration: (state, action) => {
      state.managerConfig = action.payload;
    },
    updatePreparationTime: (state, action) => {
      state.managerConfig.preparationTime = action.payload;
    },
    updateDeliveryTime: (state, action) => {
      state.managerConfig.deliveryTime = action.payload;
    },
  },
});

export const {
  setCorporationData,
  setLoading,
  setUserLogged,
  setUserData,
  setUserLanguage,
  setLanguage,
  setUserRol,
  setComponentActive,
  updateDatatableConfiguration,
  setToken,
  setUserLogOut,
  setAlert,
  removeAlert,
  updateDatatableFilter,
  updateDatatableCheckColumn,
  updateDatatableSelectedRows,
  updateDatatableRequestQuery,
  updateFloatPanelVisibility,
  setFloatPanelComponent,
  updateFloatPanel,
  setPlatformId,
  setManagerConfiguration,
  updatePreparationTime,
  updateDeliveryTime,
} = userConfigSlice.actions;
export default userConfigSlice.reducer;
